export default {
  model: {
    prop: "valor",
    event: "input"
  },
  props: {
    valor: {
      type: [String, Number, Boolean, Array, Object],
      required: true,
      note:
        "Valor padrão para todos os componentes que precisarem de alguma estrutura de v-model. Recebendo o valor e enviando para o parente.",
      default: ""
    }
  },
  data() {
    return {
      valorData: this.valor
    };
  },
  watch: {
    valor() {
      this.valorData = this.valor;
    },
    valorData() {
      this.$emit("input", this.valorData);
    }
  }
};
